import clubRequest from "../axios";
import { PaginationParams } from "./type";

const getNotifications = async (params: PaginationParams) =>
  (await clubRequest.notifyMessageList(params)).data;

const sendReadNotification = async (id: number) =>
  (
    await clubRequest.notifyMessageUpdate({
      id,
    })
  ).data;

const notificationService = {
  getNotifications,
  sendReadNotification,
};

export default notificationService;
